import type React from 'react';

import { useGetStaticAssetUrl } from '@change-corgi/core/react/assets';
import { Translate, TranslateHtml } from '@change-corgi/core/react/i18n';
import { Button } from '@change-corgi/design-system-legacy/components/actions';
import { Image } from '@change-corgi/design-system-legacy/components/media';
import { Flex } from '@change-corgi/design-system-legacy/layout';
import { Text } from '@change-corgi/design-system-legacy/typography';

import megaphone from 'src/assets/megaphone.png';

import { useFeedbackBodyModal } from '../../hooks/useFeedbackBodyModal';
import type { ModalOptions, ModalResult } from '../../hooks/useFeedbackModal';
import { FeedbackForm } from '../FeedbackForm';

type FeedbackBodyOptions = {
	onClose: (result: ModalResult) => void;
	options: ModalOptions;
};

export const FeedbackBody: React.FC<FeedbackBodyOptions> = ({ onClose, options: _options }) => {
	const { data, actions } = useFeedbackBodyModal(onClose);
	const getStaticAssetUrl = useGetStaticAssetUrl();

	if (!data.wasSubmitted) {
		return <FeedbackForm options={_options} modalData={{ actions, data }} />;
	}

	return (
		<Flex sx={{ flexDirection: 'column', mt: 64, gap: 24, textAlign: 'center' }}>
			<picture>
				<source
					type="image/webp"
					srcSet={`${getStaticAssetUrl('/images/megaphone-1x.webp')} 1x, ${getStaticAssetUrl('/images/megaphone-2x.webp')} 2x`}
				/>
				<Image
					src={megaphone}
					srcSet={`${getStaticAssetUrl('/images/megaphone-1x.webp')} 1x, ${getStaticAssetUrl('/images/megaphone-2x.webp')} 2x`}
					alt=""
					sx={{ minHeight: 100, height: 100 }}
				/>
			</picture>
			<Flex sx={{ flexDirection: 'column', gap: 8, mb: 16 }}>
				<Text fontWeight="bold" size="huge">
					<TranslateHtml value="corgi.petition.starter_dashboard.recommendations.feedback_modal.thank_you.title" />
				</Text>
				<TranslateHtml value="corgi.petition.starter_dashboard.recommendations.feedback_modal.thank_you.description" />
			</Flex>
			<Flex sx={{ flexDirection: 'row', justifyContent: 'flex-end' }}>
				<Button
					data-testid="share-recommendations-feedback-mobile-close"
					data-qa="share-recommendations-feedback-mobile-close"
					variant="primary"
					type="button"
					sx={{ width: ['100%', 'auto'] }}
					onClick={() => actions.onClose()}
				>
					<Translate value="corgi.petition.starter_dashboard.recommendations.feedback_modal.close_button" />
				</Button>
			</Flex>
		</Flex>
	);
};
